import { Module } from "vuex-class-modules";
import { CollectionStore } from "../../../../../common/src/stores/CollectionStore";
import { RawUser, ToJson } from "@gsx/common";

@Module()
export class UserCollectionStore extends CollectionStore<ToJson<RawUser>> {
    sort: keyof RawUser = "email";
}
